import { Dispatch, SetStateAction, useState } from "react";
import Button from "@mui/material/Button";
import {
  cancelTransaction,
} from "../../../services";
import {
  CancelActionResponse,
  ReplacedBy,
  SaleStatus,
} from "../../../types/sale.type";
import { useUserRole } from "../../../utils/hooks/useUserRole";
import { pushGlobalSuccess } from "../../../success/globalSuccess";
import ConfirmModal from "../../ConfirmModal";
import ReplaceFlagWarning from "./ReplaceFlagWarning";

interface CancelActionsProps {
  uuid: string;
  status: SaleStatus;
  setTriggerFetch: Dispatch<SetStateAction<number>>;
  /** The replacement bill, when a PWA replace put this bill in pending_cancel. */
  replacedBy?: ReplacedBy | null;
}

const CANCELLABLE_STATUSES: SaleStatus[] = [
  "pending",
  "paid",
  "approve",
  "pending_cancel",
];

export default function CancelActions({
  uuid,
  status,
  setTriggerFetch,
  replacedBy,
}: CancelActionsProps) {
  const { isBranchAccounting, isBranchFinance, isBranchFinanceAndAccount } =
    useUserRole();
  const canModerateCancel =
    isBranchAccounting || isBranchFinance || isBranchFinanceAndAccount;

  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  if (!canModerateCancel || !CANCELLABLE_STATUSES.includes(status)) return null;

  const isApproveCancel = status === "pending_cancel";

  const onConfirm = async () => {
    try {
      setLoading(true);
      const { data } = await cancelTransaction(uuid);
      const result: CancelActionResponse | undefined = data?.data;
      if (result?.already_cancelled) {
        pushGlobalSuccess("รายการนี้ถูกยกเลิกแล้ว");
      }
      setOpen(false);
      setTriggerFetch((prev) => prev + 1);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        size="large"
        variant="contained"
        color="error"
        onClick={() => setOpen(true)}
      >
        ยกเลิกบิล
      </Button>
      <ConfirmModal
        open={open}
        loading={loading}
        title="ยืนยันยกเลิกบิล"
        description={
          isApproveCancel
            ? "ต้องการยืนยันการยกเลิกบิลตามคำขอนี้ใช่หรือไม่ การยืนยันจะเปลี่ยนสถานะเป็น ยกเลิก"
            : "ต้องการยกเลิกบิลนี้ใช่หรือไม่ การยกเลิกจะคืนสต็อกและไม่สามารถย้อนกลับได้"
        }
        onClose={() => (loading ? undefined : setOpen(false))}
        onConfirm={onConfirm}
      >
        {isApproveCancel && <ReplaceFlagWarning replacedBy={replacedBy} />}
      </ConfirmModal>
    </>
  );
}
